registerSSRObservable